// extracted by mini-css-extract-plugin
module.exports = {"container":"careeritem-module--container--U7G8V","careerItem":"careeritem-module--career-item--1Rv33"};